import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { applyYoyGrowthPlanningDetailsChanges } from '../../api'
import { buildMarketYoyGrowthChangesPayload } from '../../lib'
import { selectMarketYoyGrowthExpectationState } from '../selectors'

export const requestApplyYoyGrowthPlanningDetailsChanges = createAsyncThunk(
  'marketYoyGrowthExpectation/requestApplyYoyGrowthPlanningDetailsChanges',
  (_: void, { getState }) => {
    const { planningDetails, planning, edits } = selectMarketYoyGrowthExpectationState(getState())

    if (!planning) {
      throw new Error('Cannot apply market YoY growth changes before planning data has loaded')
    }

    const payload = buildMarketYoyGrowthChangesPayload(planningDetails, edits)

    return applyYoyGrowthPlanningDetailsChanges({ planningEntryId: planning.entryId, payload })
  },
  {
    condition: (_, { getState }) => {
      const { edits, isSaving } = selectMarketYoyGrowthExpectationState(getState())

      return !isSaving && Object.keys(edits).length > 0
    },
  }
)
